const SecurityDashboard = () => <div>Group Threat Preparedness Dashboard</div>;

export default SecurityDashboard;
